import React, { useContext } from 'react';

import GeneralIconButton from '../../../../../../../Components/GeneralIconButton';
import ChangeLogsDetailsModal from '../ChangeLogsDetailsModal';
import useStyles from './style';
import ChangeTypeDetails from './ChangeTypeDetails';
import { convertTimeStamp } from '../../../../../../../utilities/helpers';

// MUI imports ==========
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Container, Divider, Typography } from '@mui/material';
import { Modalv2Context } from '../../../../../../../Contexts/Modalv2Context';


/**
 * @name ChangeLogsDetails
 * @description Component to display detailed change logs and handle modal interactions.
 * @param {Object} props - Component properties.
 * @param {Function} props.updateTab - Function to update the current tab.
 * @param {Object} props.changeDetails - Details of the changes to display.
 * @returns {JSX.Element} - The rendered component.
 */
const ChangeLogsDetails = ({ updateCurrentSelectedChange, currentSelectedChange }) => {

    const classes = useStyles();
    const { updateModalContent } = useContext(Modalv2Context);

    /**
     * @name handleModalOpen
     * @description Function to open the modal with the specified content and mode.
     * @param {Object} item - The item to display in the modal.
     * @param {string} mode - The mode to display in the modal.
     * @param {string} featureKey - The feature key associated with the item.
    */
    const handleModalOpen = (item, mode, featureKey) => {
        updateModalContent(
            <ChangeLogsDetailsModal
                featureKeyData={item}
                mode={mode}
                featureKey={featureKey}
            />
        );
    }


    return (
        <>
            <Container
                className={classes.container}
                sx={{ width: '100%' }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    flexWrap="wrap"
                    gap={{ xs: 2, sm: 2 }}
                >
                    <GeneralIconButton
                        color="primary"
                        fontSize="large"
                        onClick={() => { updateCurrentSelectedChange(null) }}
                        className={classes.backButton}
                        name={'ELASTIC_SEARCH_VIEW_ALL_CHANGES'}
                    >
                        <ArrowBackIcon fontSize="large" />
                    </GeneralIconButton>
                    <Box className={classes.headerText} display="flex" alignItems="center">
                        <Typography component="span" sx={{ mr: 1, fontWeight: 'bold' }}>
                            Date : {convertTimeStamp(currentSelectedChange?.timestamp).date}

                        </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderColor: 'black', mx: 1 }} />
                        <Typography component="span" sx={{ mr: 1, fontWeight: 'bold', color: '#0c4a6e', marginLeft: '1rem' }}>
                            {`Time : ${convertTimeStamp(currentSelectedChange?.timestamp).time}`}
                        </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderColor: 'black', mx: 1 }} />
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            {currentSelectedChange.action.name}
                        </Typography>
                    </Box>
                </Box>
                {
                    Object.keys(currentSelectedChange.changes).map((featureKey) => (
                        <Box className={classes.changeLog} key={featureKey} >
                            <Typography variant='h5' sx={{ fontWeight: 'bold', marginBottom: '1rem' }} className={classes.featureTitle} >
                                {featureKey}
                            </Typography>

                            <ChangeTypeDetails
                                changeDetails={currentSelectedChange}
                                featureKey={featureKey}
                                handleModalOpen={handleModalOpen}
                            />
                        </Box>
                    ))
                }
            </Container >

        </>
    )
}

export default ChangeLogsDetails
